module.exports = __webpack_public_path__ + "img/9788959894765.94cdcec5.jpg";